import { combineReducers } from "redux";
import authReducer from "./authReducer";
import errorReducer from "./errorReducer";
import profileReducer from "./profileReducer";
import postReducer from "./postReducer";
import brusselsReducer from "./brusselsReducer";
import latestBrusselsReducer from "./latestBrusselsReducer";
import citiesPostReducer from "./citiesPostReducer";
import imageReducer from "./imageReducer";
import extraNowReducer from "./extraNowReducer";

export default combineReducers({
  auth: authReducer,
  errors: errorReducer,
  profile: profileReducer,
  post: postReducer,
  brussel: brusselsReducer,
  latedBrussels: latestBrusselsReducer,
  citiespost:citiesPostReducer,
  image:imageReducer,
  extranowimage:extraNowReducer
});
